import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"
import Login from "../views/auth/Login.vue"
import Forms from "../views/Forms.vue"
import Details from "../views/Details.vue"
import Lists from "../views/Lists.vue"
import Profile from "../views/Profile.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: false,
      hideNavbar: true,
      hideBottomNav: true,
      hideMenu: true,
    },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: false,
      hideNavbar: false,
      hideBottomNav: false,
      hideMenu: true,
    },
  },
  {
    path: "/forms",
    name: "Forms",
    component: Forms,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: true,
      hideNavbar: false,
      hideBottomNav: true,
      hideMenu: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: true,
      hideNavbar: false,
      hideBottomNav: true,
      hideMenu: true,
    },
  },
  {
    path: "/detail",
    name: "Details",
    component: Details,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: true,
      hideNavbar: false,
      hideBottomNav: true,
      hideMenu: true,
    },
  },
  {
    path: "/lists",
    name: "Lists",
    component: Lists,
    meta: {
      background: "",
      center: true,
      exit: true,
      showBack: false,
      hideNavbar: false,
      hideBottomNav: false,
      hideMenu: true,
    },
  },
  { path: "*", redirect: "/" },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

export default router
